<template>
  <v-app-bar v-resize="resizeGrid" app :color="$store.getters.systemTopBarColor" clipped-left>
    <v-app-bar-nav-icon color="white" @click.stop="toggleDrawer()"></v-app-bar-nav-icon>
      <v-toolbar-title class="white--text">Call Center</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon color="white" v-if="mobileView" @click="searchDialog = true" class="mx-1" size="25">mdi-magnify</v-icon>
      <div class="mr-8 mt-0">
        <!-- <v-text-field
        class="barsearch"
        label="Search"
        background-color="white"
        solo
      ></v-text-field> -->
      <GlobalSearch v-if="ViewDashBoardCards && !mobileView"></GlobalSearch>
      </div>
      <v-toolbar-title>
        <v-menu
          v-model="menu"
          offset-y
          :close-on-content-click="false"
          style="overflow: visible!important;"
        >
          <template v-slot:activator="{ on }">
            <a v-on="on" class="white--text">
              <login-user-profile-image></login-user-profile-image>
            </a>
          </template>
          <avatar-menu></avatar-menu>
        </v-menu>
      </v-toolbar-title>
      <MobileViewglobalSearch v-if="searchDialog"/>
    </v-app-bar>
</template>
<script>
import AvatarMenu from '@/View/components/avatarmenu.vue'
import MobileViewglobalSearch from './MobileViewglobalSearch'
import store from '@/store'
import LoginUserProfileImage from '@/View/components/loginStaffProfileImage.vue'
import GlobalSearch from './globalSearch.vue'
export default {
  props: [],
  components: {
    AvatarMenu,
    GlobalSearch,
    LoginUserProfileImage,
    MobileViewglobalSearch
  },
  data () {
    return {
      searchDialog: false,
      menu: false,
      mobileView: false,
      ViewDashBoardCards: true
    }
  },
  mounted () {
    if (store.getters.permission.permissionList !== null) {
      this.ViewDashBoardCards = true
    } else {
      this.ViewDashBoardCards = false
    }
    this.$root.$on('closeMobileViewGlobalSearchDialog', () => {
      this.searchDialog = false
    })
  },
  methods: {
    resizeGrid () {
      this.innerHeight = window.innerHeight
      if (window.innerWidth < 700) {
        this.mobileView = true
      } else {
        this.mobileView = false
      }
    },
    toggleDrawer () {
      this.$store.dispatch('SetLeftDrawerToggle', !this.$store.getters.drawerToggle)
    }
  },
  beforeDestroy () {
    this.$root.$off('closeMobileViewGlobalSearchDialog')
  }
}
</script>
<style scoped>
.v-list--dense .v-list-item .v-list-item__subtitle,
.v-list--dense .v-list-item .v-list-item__title,
.v-list-item--dense .v-list-item__subtitle,
.v-list-item--dense .v-list-item__title {
  font-size: 0.9125rem !important;
  font-weight: 500 !important;
  line-height: 1rem;
}
.barsearch {
  width: 350px;
  opacity: 0.5;
}
.mobileSearch {
  width: 300px;
  opacity: 0.5;
}
.filter-green {
   filter: invert(48%) sepia(79%) saturate(906%) hue-rotate(80deg) brightness(50%) contrast(20%) grayscale(200%);
}
</style>



// WEBPACK FOOTER //
// src/View/components/topAppBar.vue